import { ref } from 'vue'
import type { FilterCondition } from '@/widgets/GlobalSearch/model/type.ts'
import { stripFilterLocalKeys } from '@/widgets/GlobalSearch/model/helpers.ts'

export const useModel = () => {
  const open = ref(false)

  const data = ref<{ name: string; items: FilterCondition[][] }>({
    name: '',
    items: [],
  })

  /**
   * Заполняет форму сохранения пресета данными без локальных UI-ключей.
   */
  const setData = (items: FilterCondition[][]) => {
    data.value = { name: '', items: stripFilterLocalKeys(items) }
  }

  /**
   * Очищает форму сохранения пресета после закрытия модального окна.
   */
  const clearData = () => {
    data.value = { name: '', items: [] }
  }

  return {
    data,
    open,

    setData,
    clearData,
  }
}
